import capitalize from "lodash/capitalize";

import {
  getRouteExternalAssigneeType,
  useExternalAssignee,
} from "@web-app/components";

import { TableRow } from "../data";

const ProviderLabel = ({ type }: { type: string }) => {
  if (!type) return null;

  const label = capitalize(type);

  return (
    <div className="flex items-center gap-2">
      <img
        src={`/images/${type}.png`}
        alt={`${label} logo`}
        className="h-5 w-5 object-contain"
      />
      <span>{label}</span>
    </div>
  );
};

export default function DeliveryProviderCell({ data }: { data: TableRow }) {
  const { externalAssigneeType } = useExternalAssignee(data);

  if (data?.entity === "order") {
    // Orders in a route handed off to a provider are delivered by that provider
    const routeExternalAssigneeType = getRouteExternalAssigneeType(data.route);

    return (
      <ProviderLabel
        type={routeExternalAssigneeType || (externalAssigneeType ?? "")}
      />
    );
  }

  if (data?.entity === "route") {
    return <ProviderLabel type={getRouteExternalAssigneeType(data)} />;
  }

  return null;
}
